<div matDialogTitle class="text-accent" style="font-size: x-large">Hilfe - ego4you Kids & Teens Reservierung</div>

<mat-divider />

<mat-dialog-content>
  <div style="font-size: small">
    <div style="margin-top: 10px">
      <h2>Wie viele Begleitpersonen dürfen mein Kind beim Gesundheitsevent begleiten?</h2>
    </div>

    <div class="answer">
      <p>
        Pro anspruchsberechtigtem Kind ist eine Begleitperson kostenfrei zur Veranstaltung eingeladen. Für jede weitere
        Person ist am Eventtag in Telfs, Graz, Faaker See, Wien und Fuschl am See ein Unkostenbeitrag in Höhe von EUR
        25,- vor Ort direkt zu bezahlen (Kinder unter 6 Jahren sind dabei kostenfrei). In der Therme Loipersdorf
        entfällt der Unkostenbeitrag. Jede zusätzliche Begleitperson erhält stattdessen eine Ermäßigung auf den jeweils
        gültigen Tagestarif in der Therme Loipersdorf. Jede Begleitperson kann das Rahmenprogramm in Anspruch nehmen,
        jedoch nicht an den Fitness- & Bewegungsworkshops teilnehmen.
      </p>
    </div>

    <div style="margin-top: 10px">
      <h2>Beginnzeit</h2>
    </div>

    <div class="answer">
      <p>
        Die genauen Beginnzeiten des Gesundheitsevents sind im Reservierungssystem ersichtlich und werden zusätzlich mit
        der schriftlichen Reservierungsbestätigung rechtzeitig vor Veranstaltungsbeginn per Post übermittelt.
      </p>
    </div>

    <div style="margin-top: 10px">
      <h2>Was ist mit Rahmenprogramm gemeint?</h2>
    </div>

    <div class="answer">
      <p>
        Das Rahmenprogramm ergänzt den Untersuchungsteil und beinhaltet spannende Outdooraktivitäten, Kreatives und
        Sportliches für Kinder und Begleitpersonen.
      </p>
    </div>

    <div style="margin-top: 10px">
      <h2>Gibt es die Möglichkeit mehrere Kinder in einem Vorgang zu reservieren?</h2>
    </div>

    <div class="answer">
      <p>
        Ja, vorausgesetzt die Kinder sind für diesen Event anspruchsberechtigt und es gibt genug freie Plätze für den
        gewünschten Termin. In diesem Fall können alle berechtigten Kinder im Zuge der Reservierung durch aktivieren der
        Checkbox zur Reservierung hinzugefügt werden.
      </p>
    </div>

    <div style="margin-top: 10px">
      <h2>Ich habe meinen Code vergessen?</h2>
    </div>

    <div class="answer">
      <p>
        Bitte kontaktieren Sie für Rückfragen bezüglich des Anmeldecodes die ego4you Kids & Teens Informationsstelle der
        Merkur Lifestyle (Tel.: <a href="tel:0800220309">0800 22 03 09</a>, Mo.-Do. 09:00 bis 15:00 und Fr. 09:00 bis
        14:00).
      </p>
    </div>

    <div style="margin-top: 10px">
      <h2>Warum ist nur eines meiner Kinder in der Applikation angeführt?</h2>
    </div>

    <div class="answer">
      <p>
        Da Kinder nur alle zwei Jahre anspruchsberechtigt sind kann es sein, dass heuer nicht alle ihre Kinder am
        Programm teilnehmen können. Rückfragen sind bitte an die ego4you Kids & Teens Informationsstelle der Merkur
        Lifestyle (Tel.:
        <a href="tel:0800220309">0800 22 03 09</a>, Mo.-Do. 09:00 bis 15:00 und Fr. 09:00 bis 14:00) zu richten.
      </p>
    </div>

    <div style="margin-top: 10px">
      <h2>Wie lange vor einem Termin kann ich kostenfrei stornieren?</h2>
    </div>

    <div class="answer">
      <p>
        Eine kostenfreie Stornierung des von uns bestätigten Termins ist bis 2 Wochen vor dem jeweiligen
        Veranstaltungstag im Online-Reservierungssystem möglich. Bei späterer Absage oder Nichterscheinen behalten wir
        uns das Recht vor, eine Stornogebühr in der Höhe von EUR 50,- in Rechnung zu stellen. Die Stornogebühr entfällt
        nur dann, wenn mittels ärztlichem Attest nachgewiesen wird, dass eine Teilnahme des Kindes aus gesundheitlichen
        Gründen nicht möglich ist. Das ärztliche Attest muss spätestens 2 Wochen nach dem verpassten Termin bei uns
        eingelangt sein.
      </p>
    </div>
  </div>
  <mat-divider />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" mat-dialog-close>OK</button>
</mat-dialog-actions>
